import { z } from 'zod';

import { IsoDate } from '../primitives';

/** Timestamps every CMS row carries (docs/02 §1). */
export const Timestamps = z.object({
  createdAt: IsoDate,
  updatedAt: IsoDate,
});
export type Timestamps = z.infer<typeof Timestamps>;

export const SoftDelete = z.object({ deletedAt: IsoDate.nullable() });
export type SoftDelete = z.infer<typeof SoftDelete>;

/** Optional date window on list endpoints (`from`/`to` inclusive, ISO-8601). */
export const DateRangeQuery = z.object({
  from: IsoDate.optional(),
  to: IsoDate.optional(),
});
export type DateRangeQuery = z.infer<typeof DateRangeQuery>;

/** Free-text filter used by most CMS list endpoints. */
export const TextFilter = z.string().trim().min(1).max(100);

/** Row-level error of a CSV bulk import (dry-run or real). */
export const RowError = z.object({
  row: z.number().int().min(1),
  message: z.string(),
});
export type RowError = z.infer<typeof RowError>;
